export const USE_TOKEN_ID_AS_OFFER_ID = false;
